<template>
  <div v-show="visible" class="m-message">
    <div class="toastbox">
      <div class="iconBox"><img src="../../assets/trade/icon_message_success.svg" alt="logo"/></div>
      <div class="rightBox">
        <div class="content">
          <div v-if="content" class="data">{{ content }}</div>
          <div class="scan" @click="viewHash(hash)"></div>
        </div>
        <div class="closeBox">
          <img alt="" src="../../assets/trade/icon_trade_close.svg" @click="handleClose"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {viewHash} from '@/utils/common';

export default {
  name: 'message',
  props: {
    iconImg: String,
    closable: Boolean,
    closeHandler: Function,
    title: String,
    content: String,
    supportHTML: Boolean, // content support html
    isCollapsed: {
      type: Boolean,
      default: true,
    },
    collapsable: {
      type: Boolean,
      default: true,
    },
    hash: String,
  },
  data() {
    return {
      visible: true,
      collapsed: this.isCollapsed,
    };
  },
  methods: {
    viewHash,
    triggerCollapse() {
      this.collapsed = !this.collapsed;
    },
    close() {
      this.visible = false;
    },
    handleClose() {
      if (typeof this.closeHandler === 'function') this.closeHandler(this.close);
      else this.close();
    },
  },
};
</script>

<style lang="scss" scoped>

.toastbox {
  width: 300px;
  min-height: 100px;
  border-radius: 10px;
  background-color: rgba(48, 64, 22, 0.54);
  display: flex;
}

.iconBox {
  width: 64px;
  img {
    margin-top: 22px;
    margin-left: 13px;
    width: 20px;
    height: 20px;
  }
}

.closeBox {
  width: 85px;
  text-align: right;
  img {
    margin-top: 10px;
    margin-right: 10px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}

.rightBox {
  flex: 1;
  display: flex;
  .content {
    display: flex;
    flex: 1;
    justify-content: center;
    flex-direction: column;
    .data {
      font-family: PingFangHK;
      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 20px;
      letter-spacing: normal;
      text-align: left;
      color: var(--white);
    }
    .scan {
      margin-top: 6px;
      font-family: PingFangHK;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: left;
      color: #3e6bff;
      cursor: pointer;
    }
  }
}
</style>
